
import { GetEventByIdRequest, GetEventRequest } from "@aoe/client";
import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { EventDetailResponse, EventListResponse } from "src/app/core/interfaces/EventsResponse.interface";

export const eventActions = createActionGroup({
    source: '[Event]',
    events: {
        'Load event': props<{ payload?: GetEventRequest }>(),
        'Load success': props<EventListResponse>(),
        'Load failed': props<EventListResponse>(),

        'Load event by Id': props<{ payload: GetEventByIdRequest }>(),
        'Load success by Id': props<EventDetailResponse>(),
        'Load failed by Id': props<EventDetailResponse>(),

        'reset sleected event': emptyProps


    }
})